import { Component, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { EmployeeLeaveManagementService } from '../Model/EmployeeLeaveManagement/employee-leave-management.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';

@Component({
  selector: 'app-leave-closing-detail',
  standalone: true,
  imports: [DataTablesModule, CommonModule, NgSelectModule, FormsModule, LoaderComponent],
  templateUrl: './leave-closing-detail.component.html',
  styleUrl: './leave-closing-detail.component.scss'
})
export class LeaveClosingDetailComponent {

  @Input() data = [] as any
  dtoptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  isDisabled: boolean = false;

  Actions = [{ label: 'No Action', value: 'No Action' }, { label: 'Addition', value: 'Addition' }, { label: 'Deduction', value: 'Deduction' }]

  constructor(
    private activeModal: NgbActiveModal,
    public common: CommonService,
    public leave: EmployeeLeaveManagementService,
    public toast: ToastService,
    private modalService: NgbModal
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit() {
    this.data.forEach((e: any) => {
      e.action = 'No Action',
        e.count = 0,
        e.description = ''
    });
    console.log(this.data);
  }

  close() {
    this.activeModal.close();
  }

  onSubmit(form: any) {
    if (form.valid) {
      this.LeaveBalanceSaveUpdate();
    } else {
      form.submitted = true;
    }
  }

  LeaveBalanceSaveUpdate() {
    this.isDisabled = true;
    console.log(this.data);

    for (let i = 0; i < this.data.length; i++) {
      const e = this.data[i];
      if (e.action !== 'No Action') {
        if (e.count < 1) {
          this.toast.show({ message: 'Addition or Deduction Count should be greater than 0!', type: toastTypeEnum.warning });
          this.isDisabled = false;
          return;
        }
      }
    }

    let leavedata = this.data.map((e: any) => ({
      EmpMasterId: e.EmpMasterID,
      LeaveMasterId: e.LeaveMasterID,
      InputType: e.action,
      YearName: e.YearName,
      Value: Number(e.count),
      Description: e.description
    }))
    this.leave.LeaveClosingBalanceDetail({
      SelectType: 'I',
      ESS_EmpMonthlyLeaveCredited: leavedata
    }).subscribe({
      next: (response) => {
        if (response.Errorcode == "01") {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.ErrorMsg;
          modalRef.result.then((result: any) => {
            if (result) {
              this.activeModal.close(true);
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.ErrorMsg;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      error: (err: any) => {
        this.isDisabled = false;
      }
    })
  }

  onKeyPressNumbersOnly(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    const input = (event.target as HTMLInputElement).value;
    const dotCount = input.split('.').length - 1;
    const minusCount = (input.match(/-/g) || []).length;
    const cursorPosition = (event.target as HTMLInputElement).selectionStart;
    if (
      (charCode !== 46 && charCode !== 45 && (charCode < 48 || charCode > 57)) || // Not a number, decimal point, or minus
      (dotCount > 0 && charCode === 46) ||
      (charCode === 45 && cursorPosition !== 0) || // Minus sign not at the beginning
      (minusCount > 0 && charCode === 45) // More than one minus sign
    ) {
      event.preventDefault();
      return;
    }

    if (input.includes('.') && input.split('.')[1].length >= 2) {
      if (charCode >= 48 && charCode <= 57) {
        event.preventDefault();
        return;
      }
    }

  }
}